import BvWrapper from './code/Scripts/Components/BvWrapper.vue';
import BvScrollTagging from './code/Scripts/Components/BvScrollTagging.vue';

export default {
  components: {
    BvWrapper,
    BvScrollTagging,
  },
};
